import '../styles/bgs.css';
import One from '../components/SeasonsGreetings/One';
import Four from '../components/SeasonsGreetings/Four';
import { useEffect, useMemo, useState } from 'react';

function SeasonsGreetings() {
  const [access, setAccess] = useState(null); // null | 'user' | 'dev'
  const [password, setPassword] = useState('');
  const [pwError, setPwError] = useState('');
  const [snowOn, setSnowOn] = useState(true);

  useEffect(() => {
    if (access === 'dev' || access === 'user') setSnowOn(true);
  }, [access]);


  const flakes = useMemo(() => {
    // Mix of small + original + bigger flakes for depth.
    const make = (count, sizeMin, sizeMax, durMin, durMax, opacityMin, opacityMax, driftMin, driftMax, idBase, shapeChance) =>
      Array.from({ length: count }).map((_, i) => {
        const size = sizeMin + Math.random() * (sizeMax - sizeMin); // px
        const left = Math.random() * 100; // %
        const opacity = opacityMin + Math.random() * (opacityMax - opacityMin);
        const drift = driftMin + Math.random() * (driftMax - driftMin); // px
        const duration = durMin + Math.random() * (durMax - durMin); // s
        const delay = -Math.random() * duration; // negative => already "in progress"
        const kind = Math.random() < shapeChance ? 'shape' : 'dot';
        return { id: idBase + i, size, left, opacity, drift, duration, delay, kind };
      });

    const small = make(22, 1.5, 4.0, 7.0, 14.0, 0.10, 0.26, -22, 22, 0, 0.10);
    const base = make(28, 2.0, 7.0, 6.0, 15.0, 0.15, 0.35, -24, 24, 1000, 0.18); // original-ish sizes
    const big = make(14, 7.0, 14.0, 9.0, 20.0, 0.08, 0.22, -30, 30, 2000, 0.55);
    // Three extra larger tiers
    const huge = make(10, 14.0, 20.0, 12.0, 24.0, 0.06, 0.18, -34, 34, 3000, 0.75);
    const xl = make(6, 20.0, 28.0, 14.0, 28.0, 0.05, 0.16, -40, 40, 4000, 0.85);
    const xxl = make(3, 28.0, 40.0, 18.0, 34.0, 0.04, 0.14, -50, 50, 5000, 0.95);

    return [...small, ...base, ...big, ...huge, ...xl, ...xxl];
  }, []);

  if (access === null) {
    return (
      <div className="w-full main-div">
        <div className="container mx-auto px-4 py-20">
          <div className="mx-auto w-full max-w-[520px] bg-white border border-black/10 rounded-lg p-6">
            <h2 className="text-black font-normal text-xl">Access</h2>
            <form
              className="mt-4 flex flex-col gap-3"
              onSubmit={(e) => {
                e.preventDefault();
                const p = password.trim();
                if (p === 'happyNY2026') {
                  setAccess('user');
                  setPwError('');
                  return;
                }
                setPwError('Incorrect password');
              }}
            >
              <input
                type="text"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (pwError) setPwError('');
                }}
                className="w-full border border-black/20 rounded-md px-3 py-2"
                placeholder="Enter password"
                name="xmas_password"
                autoComplete="off"
                autoFocus
              />
              {pwError ? <div className="text-sm text-red-600">{pwError}</div> : null}
              <button type="submit" className="w-full py-2 px-4 bg-[#c0834d] text-white rounded hover:bg-[#a87442] transition-colors ">
                Continue
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  if (access === 'user') {
    return (
      <div className="w-full main-div relative">
        {snowOn && (
          <div className="sg-snow-layer z-20">
            {flakes.map((f) => (
              <span
                key={f.id}
                className={`sg-snowflake ${f.kind === 'shape' ? 'sg-snowflake--shape' : ''}`}
                style={{
                  left: `${f.left}%`,
                  width: `${f.size}px`,
                  height: `${f.size}px`,
                  opacity: f.opacity,
                  animationDuration: `${f.duration}s`,
                  animationDelay: `${f.delay}s`,
                  ['--sg-drift']: `${f.drift}px`,
                }}
              />
            ))}
          </div>
        )}
        {/* <div className="container mx-auto px-4 py-8 my-[120px] xl:mb-[65px] xl:mt-[90px]">
          <One />
        </div> */}
        <div className="container mx-auto px-4 py-8 my-[120px] xl:mb-[65px] xl:mt-[90px]">
          <Four />
        </div>
      </div>
    );
  }
}

export default SeasonsGreetings; 